<script lang="ts" setup>
import { translate } from '@/i18n/i18n.ts'
import { formatPrice } from '@/utils/price.util.ts'
import { usePriceDisplayState } from '@/composables/state/price-display-state.composable.ts'

export type PriceDisplayProps = {
  price?: number | undefined
  isLoading: boolean
  isValid: boolean
}

const props = defineProps<PriceDisplayProps>()

const state = usePriceDisplayState(props)
const { classes, showPrefix, showPriceNumber } = state
</script>

<template>
  <div :class="classes">
    <div class="price-display__outer-circle">
      <div class="price-display__inner-circle">
        <div v-if="showPrefix" class="price-display__label">
          {{ translate('product.payment_prefix_from') }}
        </div>
        <div class="price-display__price">
          <span v-if="showPriceNumber">{{ formatPrice(price!) }}</span>
          <span v-else><span class="price-display__invalid"></span> €</span>
        </div>
        <div class="price-display__label">{{ translate('product.payment_interval_monthly') }}</div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import 'a-price-display';
</style>
